module.exports = __webpack_public_path__ + "components/country-flag/static/ky-13da8c6287fbe6aaffd0ab8a454cb1b3.svg";